// src/components/questionnaire/QuestionnaireChooser.tsx
import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { QUESTIONNAIRES } from "../../utils/constants";

export const QuestionnaireChooser = memo(function QuestionnaireChooser({
  permittedQuestionnaires = [],
}) {
  const { t } = useTranslation("common");
  const questionnaires = QUESTIONNAIRES.filter(({ slug }) =>
    permittedQuestionnaires.includes(slug),
  );

  return (
    <div className="w-full flex flex-col items-center gap-4 max-w-lg p-4">
      <h1 className="subtitle-text">{t("questionnaireChooser.title")}</h1>

      <div className="w-full grid grid-cols-2 gap-4">
        {questionnaires.map(({ slug, labelKey }) => (
          <Link
            key={slug}
            to={`/questionnaires/${slug}`}
            className="primary-button w-full text-center"
          >
            {t(labelKey)}
          </Link>
        ))}
      </div>
    </div>
  );
});
